import { css } from '@emotion/css';
import {
  N0,
  N50,
  N200,
  N700,
  N900,
  R500,
  R200,
  Y500,
  primary,
  primaryDark,
} from '@assets/colors';

export const styToggleBtn = css`
  display: flex;
  border: solid 1px ${N50};
  border-radius: 20px;
  padding: 4px;
  width: fit-content;
`;

export const styBtn = props => css`
  cursor: pointer;
  font-weight: bold;
  text-align: center;
  box-shadow: none;
  border: none;
  outline: none;
  letter-spacing: 0.05em;
  white-space: nowrap;
  vertical-align: middle;
  border-radius: 8px;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  ${props.size === 'xs' && 'font-size: 12px; padding: 4px 8px;'}
  ${props.size === 'sm' && 'font-size: 14px; padding: 8px 16px;'}
  ${props.size === 'md' && 'font-size: 17px; padding: 11px 16px;'}

  ${props.fluid && 'width: 100%;'}
  
  /* Button Primary */
  ${props.variant === 'primary'
  && `
    min-width: 82px;
    color: ${N0};
    background-color: ${primary};

    :hover,
    :visited,
    :active,
    :focus {
      background-color: #0858d9;
      outline: none;
    }

    :disabled {
      background-color: ${N50};
    }
  `}

  /* Button Secondary */
  ${props.variant === 'secondary'
  && `
    min-width: 82px;
    color: ${primary};
    background-color: ${N0};
    border: solid 1px ${primary};

    :hover,
    :visited,
    :active,
    :focus {
      color: ${primary};
      background-color: ${N50};
      outline: none;
    }

    :disabled {
      background-color: ${N0};
      border: solid 1px ${N200};
    }
  `}

  /* Button Tertiary */
  ${props.variant === 'tertiary'
  && `
    min-width: 82px;
    color: ${N700};
    background-color: ${N0};
    border: solid 1px ${N200};

    :hover,
    :visited,
    :active,
    :focus {
      color: ${N700};
      background-color: ${N50};
      outline: none;
    }

    :disabled {
      background-color: ${N0};
      border: solid 1px ${N200};
    }
  `}

  /* Button Quartenary */
  ${props.variant === 'quartenary'
  && `
    min-width: 82px;
    color: ${primary};
    background-color: ${N0};

    :hover,
    :visited,
    :active,
    :focus {
      color: ${primary};
      background-color: ${N50};
      outline: none;
    }

    :disabled {
      background-color: ${N0};
    }
  `}

  /* Button Danger */
  ${props.variant === 'danger'
  && `
    min-width: 82px;
    color: ${N0};
    background-color: ${R500};

    :hover,
    :visited,
    :active,
    :focus {
      background-color: ${R200};
      outline: none;
    }

    :disabled {
      background-color: ${N50};
    }
  `}

  /* Button Danger Outlined */
  ${props.variant === 'danger-outlined'
  && `
    min-width: 82px;
    color: ${R200};
    background-color: ${N0};
    border: solid 1px ${R200};

    :hover,
    :visited,
    :active,
    :focus {
      background-color: ${N50};
      outline: none;
    }

    :disabled {
      background-color: ${N50};
    }
  `}

  /* Button Topup */
  ${props.variant === 'topup'
  && `
    color: ${primaryDark};
    background-color: ${Y500};
  `}

  :disabled {
    cursor: not-allowed;
    color: ${N200};

    :hover,
    :visited,
    :active,
    :focus {
      text-decoration: none;
      outline: none;
    }
  }

  /* Button Grey outlined */
  ${props.variant === 'grey-outlined'
  && `
    color: ${N900};
    background-color: ${N0};
    border-radius: 4px !important;
    outline: 1px solid ${N200} !important;
    box-shadow: none !important;

  
    :focus {
      outline: 1px solid ${N200};
    }
  `}
`;

export const styBtnIcon = props => css`
  ${props.size === 'sm' ? 'height: 16px;' : 'height: 24px;'}
  vertical-align: text-bottom;
  ${props.iconPosition === 'left'
    ? 'margin-right: 12px;'
    : 'margin-left: 12px;'}
`;

export const styBtnTooltip = css`
  background: ${N0};
  width: 300px;

  box-shadow: 0px 8px 28px -6px rgba(51, 51, 51, 0.12),
    0px 18px 88px -4px rgba(51, 51, 51, 0.14);
  border-radius: 16px;
  padding: 24px;
  z-index: 9999;
`;
